/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskTimestampISO } from '../../../../../../../models/task.model';
import { CustomDateFormatService } from '../../../../../../../services/custom-date-format/custom-date-format.service';

@Component({
  selector: 'app-timestamp-item',
  templateUrl: './timestamp-item.component.html',
  styleUrls: ['./timestamp-item.component.scss'],
  standalone: false
})
export class TimestampItemComponent implements OnInit {
  @Input() timestampItem: TaskTimestampISO = new TaskTimestampISO('');

  constructor(public customDateFormatService: CustomDateFormatService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
